import { PeriodProgressState, PulseBetPeriod } from "../../ViewModel";

export class CalculatedPeriod {

    index: number;
    isLast: boolean;
    period: PulseBetPeriod;
    calculatedWin: number;
    formatedWin: string;
    periodDurationInMilli: number;
    relativePercentFromTotal: number;
    absolutePercentFromTotal: number;
    invertedStartTimeInMinutesFormat: string;
    absoluteToGameFormattedGameStart: string;
    absoluteGameFormattedGameEnd: string;
    absoluteToGameStartInMilli: number;
    absoluteToGameEndInMilli: number;
    relativeRangeFormatted: string;
    periodProgressState?: PeriodProgressState;

    constructor(source: {
        index: number,
        isLast: boolean,
        period: PulseBetPeriod,
        calculatedWin: number,
        formatedWin: string,
        periodDurationInMilli: number,
        relativePercentFromTotal: number,
        absolutePercentFromTotal: number,
        invertedStartTimeInMinutesFormat: string,
        absoluteToGameFormattedGameStart: string,
        absoluteGameFormattedGameEnd: string,
        absoluteToGameStartInMilli: number,
        absoluteToGameEndInMilli: number,
        relativeRangeFormatted: string,
        periodProgressState?: PeriodProgressState,
    }) {

        this.index = source.index;
        this.isLast = source.isLast;
        this.period = source.period;
        this.calculatedWin = source.calculatedWin;
        this.formatedWin = source.formatedWin;
        this.periodDurationInMilli = source.periodDurationInMilli;
        this.relativePercentFromTotal = source.relativePercentFromTotal;
        this.absolutePercentFromTotal = source.absolutePercentFromTotal;
        this.invertedStartTimeInMinutesFormat = source.invertedStartTimeInMinutesFormat;
        this.absoluteToGameFormattedGameStart = source.absoluteToGameFormattedGameStart;
        this.absoluteGameFormattedGameEnd = source.absoluteGameFormattedGameEnd;
        this.absoluteToGameStartInMilli = source.absoluteToGameStartInMilli;
        this.absoluteToGameEndInMilli = source.absoluteToGameEndInMilli;
        this.relativeRangeFormatted = source.relativeRangeFormatted;

        this.periodProgressState = source.periodProgressState;
    }
}